export const allFormTypes = {
    individual: [
        '1040 - Return Transcript',
        '1040 - Record of Account',
        'W-2 - Employee Earnings',
        '1099 - All Types',
        'All Income Data',
    ],
    business: [
        '1065 - Partnership Return Transcript',
        '1065 - Partnership Record of Account',
        '1120 - Corporate Return Transcript',
        '1120 - Corporate Record of Account',
        '1120S - S Corporation Return Transcript',
        'All Income Data',
    ]
}
